// @flow
import { randomInRange } from "../helpers"
import { HEIGHT_DIVIDER } from "../constants"

export const randomPosition = (radius: number) => ({
  x: randomInRange(radius, window.innerWidth - radius),
  y: randomInRange(radius, window.innerHeight / HEIGHT_DIVIDER - radius)
})
